import React from 'react';
import './Overview.css';

const Overview: React.FC = () => {
  return (
    <div className="overview-container">
      <h1>Product Carbon Footprint Tracking Demo</h1>
      
      <section className="overview-section">
        <h2>About This Demo</h2>
        <p>
          This interactive demonstration showcases how small businesses can track and reduce 
          their product carbon footprint using solutions from AWS. In this example, a 
          home-based fudge business is used as an example.
        </p>
      </section>

      <section className="overview-section">
        <h2>Key Features</h2>
        <ul>
          <li><strong>Emissions Factor Estimates</strong> - GenAI powered by <a href="https://www.amazon.science/publications/parakeet-emission-factor-recommendation-for-carbon-footprinting-with-generative-ai" target="_blank" rel="noopener noreferrer">Amazon Science's Parakeet</a></li>
          <li><strong>Real-time Production Tracking</strong> - Monitor energy consumption during production batches</li>
          <li><strong>Solar Integration</strong> - Calculate net grid usage after solar energy offset</li>
          <li><strong>Emissions Calculation</strong> - Track CO2e from ingredients and energy consumption</li>
          <li><strong>Analytics Dashboard</strong> - Visualize emissions breakdown and energy sources</li>
        </ul>
      </section>

      <section className="overview-section">
        <h2>How It Works</h2>
        <ol>
          <li>Ingredients are loaded into the system, with emissions estimates generated via Amazon Bedrock</li>
          <li>Recipes are loaded pulling from the ingredients, summing the emissions estimates for each batch</li>
          <li>When a batch is made, the recipe is selected and energy consumed during production is recorded via energy monitoring outlet connected via AWS IoT Core</li>
          <li>Solar production data is fetched from NREL API for the home-based business</li>
          <li>Emissions are calculated: ingredients + (net grid usage × carbon intensity)</li>
          <li>Data is stored in S3 and analyzed via Athena and QuickSight</li>
        </ol>
      </section>

      <section className="overview-section">
        <h2>Get Started</h2>
        <p>
          Browse the <strong>Ingredients</strong> and <strong>Recipes</strong> pages to see 
          emissions estimates generated by GenAI. Navigate to the <strong>Production</strong> tab 
          to see history of batches made, or view the <strong>Analytics</strong> tab to see 
          emissions and energy breakdowns. Check out the <strong>Demo Architecture</strong> page 
          for technical details and reference architectures for each component.
        </p>
      </section>
    </div>
  );
};

export default Overview;
